export default __webpack_public_path__ + "static/media/deliberatereprisal.5506eb78.png";